import React, {Component} from 'react'

class TableHeadItems extends Component {
    render() {
        return (
            <thead className="TableHeadItems">
            <tr>
                <th>#</th>
                <th>ID</th>
                <th>Số thùng</th>
                <th>Loại sản phẩm</th>
                <th>Size</th>
                <th>Location</th>
                <th>Shipping carrier</th>
                <th>Tracking</th>
                <th>Thời gian đóng gói</th>
                <th>Ngày Multrans nhận</th>
                <th>Delivered at</th>
                <th>Số ngày ship</th>
                <th>Shipment status</th>
                <th>Hành động</th>
            </tr>
            </thead>
        )
    }
}

export default TableHeadItems
